import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaInstagram, FaTiktok } from "react-icons/fa";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  return (
    <footer
      className={`relative w-full text-white font-signika ${className || ""}`}
      style={{
        backgroundImage: "url('/images/bg-fashion.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}>
      {/* Overlay */}
      <div className="absolute inset-0 bg-purple-900/90" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-10">
        <div className="grid md:grid-cols-2 gap-10">
          {/* LEFT */}
          <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-12">
            {/* Brand */}
            <div className="max-w-sm">
              <h2 className="text-2xl md:text-3xl font-bold tracking-wide">HIJAFERA</h2>

              <p className="mt-3 text-sm md:text-base text-gray-200 leading-relaxed">Hijab & Fashion Muslimah modern dengan kualitas terbaik. Tampil elegan, nyaman, dan percaya diri dalam setiap aktivitas.</p>

              {/* Social */}
              <div className="flex gap-4 mt-4 text-lg">
                <a href="#" className="hover:text-orange-400 transition">
                  <FaInstagram />
                </a>
                <a href="#" className="hover:text-orange-400 transition">
                  <FaTiktok />
                </a>
              </div>
            </div>

            {/* Contact */}
            <div className="flex flex-col gap-4 text-sm md:text-base">
              <div className="flex items-start gap-3">
                <div className="bg-primary2 p-3 rounded-full shrink-0">
                  <FaMapMarkerAlt />
                </div>

                <div className="text-gray-200 leading-relaxed">
                  <p className="font-semibold text-white mb-1">Alamat</p>
                  Jakarta, Indonesia
                  <br />
                  (Warehouse & Office)
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="bg-primary2 p-3 rounded-full shrink-0">
                  <FaEnvelope />
                </div>

                <div className="text-gray-200">
                  <p className="font-semibold text-white mb-1">Email</p>
                  support@hijafera.com
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="bg-primary2 p-3 rounded-full shrink-0">
                  <FaPhoneAlt />
                </div>

                <div className="text-gray-200">
                  <p className="font-semibold text-white mb-1">Customer Service</p>
                  +62 812-xxxx-xxxx
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT - MAP */}
          <div className="w-full h-[260px] rounded-xl overflow-hidden border border-white/20 shadow-lg">
            <iframe src="https://maps.google.com/maps?q=jakarta&t=&z=13&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" loading="lazy" className="border-0"></iframe>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="relative z-10 border-t border-white/20 text-center py-4 text-xs md:text-sm bg-purple-950/90">© {new Date().getFullYear()} HIJAFERA. All Rights Reserved</div>
    </footer>
  );
};

export default Footer;
